import React from 'react';
import { filter } from 'lodash';
import { Box, FlexBox, Typography, Incrementor, color, Grid, SvgIcon } from '@kis-technologies/kis-ui';
import CityPassCircleLogo from 'assets/CityPASS_Circle_Logo.png';
import { useStyles } from '../styled';
import { TicketRowProps } from '../types';

/**
 * Row with border text and incrementor - used in the ticketing flow
 */

export const TicketRow = (props: TicketRowProps) => {
  const { offer, updateAmount, currentCart, ticketLimit, orderLimit, index, formattedPrice } = props;
  const { type } = offer;

  const classes = useStyles();

  const getGroupCount = () => currentCart.filter((cart) => cart.groupId === offer.groupId).length;
  const currentValue = filter(currentCart, offer.purchaseParams).length;
  const groupLimitReached =
    offer.groupLimit && offer.groupLimit <= getGroupCount() && offer.groupLimit >= 0 ? true : false;
  const typeLimitReached = offer.typeLimit && offer.typeLimit <= currentValue ? true : false;
  const orderLimitValue =
    orderLimit && offer.availability < orderLimit && offer.availability >= 0 ? offer.availability : orderLimit;

  return (
    <FlexBox
      fullWidth
      align="center"
      bg="white"
      padding="3 5"
      border="solid 1px #c8c8c8"
      key={type}
      sx={{ minHeight: '125px' }}
    >
      <Grid className={classes.ticketRowType}>
        <Typography variant="h4">{type}</Typography>
      </Grid>
      <FlexBox margin="0 0 0 auto" flexOverride="none" align="center">
        {offer.isPromoCodeOffer && (
          <FlexBox align="center" margin="0 5 0 0" data-testid={`ticket-promo-icon-${index}`}>
            <SvgIcon name="success_circle" color="#64af13" size={60} />
          </FlexBox>
        )}
        {offer.isCityPassEligible && (
          <img
            src={CityPassCircleLogo}
            alt="City PASS Logo"
            className={classes.cityPassImage}
            data-testid={`city-pass-logo-${index}`}
          />
        )}
        <Incrementor
          testId={index}
          displayValue={currentValue}
          negativeIsDisabled={currentValue === 0}
          positiveIsDisabled={
            currentValue >= Number(ticketLimit) ||
            currentCart.length >= Number(orderLimitValue) ||
            groupLimitReached ||
            typeLimitReached
          }
          onPositiveClick={() => updateAmount(offer, 'add')}
          onNegativeClick={() => updateAmount(offer, 'subtract')}
        />
      </FlexBox>
      <Box width={2} margin="0 7 0 3" height={70} sx={{ backgroundColor: color.X_LIGHT_GRAY }} />
      <FlexBox width={70} align="center" justify="end">
        <Typography fontSize={24} fontWeight={700}>
          {formattedPrice}
        </Typography>
      </FlexBox>
    </FlexBox>
  );
};
